export default "__VITE_ASSET__EH5iudik__"